<template>
  <div>
    <div
      class="modal fade"
      id="modal-form-inspeccion"
      style="background-color: #00000082"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Inspección</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="card-body p-0">
              <table
                class="table table-striped table-bordered table-hover table-md"
              >
                <thead class="thead-dark">
                  <tr>
                    <th>Inspeccion</th>
                    <th class="text-center text-nowrap">Acción</th>
                  </tr>
                </thead>
                <tbody v-if="arrayFinal.length > 0">
                  <tr
                    v-for="item of arrayFinal"
                    :key="item.formato_inspeccion_id"
                  >
                    <td>
                      <div>{{ item.info_formato.nombre }}</div>
                      <small
                        v-if="mostrarNombreUltimaMensual(item)"
                        class="d-block text-muted"
                      >
                        {{ nombreFormatoUltimaMensual(viaje) }}
                      </small>
                      <span
                        v-if="esFormatoMensual(item)"
                        class="badge d-inline-block text-wrap mt-1"
                        :class="valInspeccionFechasMsgBadge(viaje)"
                      >
                        {{ valInspeccionFechasMsg(viaje, item) }}
                      </span>
                    </td>
                    <td class="text-center text-nowrap align-middle">
                      <button
                        v-if="
                          item.info && item.info.id && !mostrarBotonCrear(item)
                        "
                        type="button"
                        class="btn btn-sm btn-default py-0"
                        style="cursor: pointer"
                        @click="edit(item.info.id)"
                      >
                        {{ item.info.id }}
                      </button>
                      <button
                        v-else-if="mostrarBotonCrear(item)"
                        type="button"
                        class="btn btn-info"
                        style="cursor: pointer"
                        @click="inspeccion(viaje, item.info_formato)"
                      >
                        <i class="fas fa-plus-square"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="2" class="text-center text-muted">
                      No hay formatos de inspección activos asignados a este
                      sitio.
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "VentanaOperacionesInspeccion",
  components: {},
  data() {
    return {
      inspecciones: {},
      viajeInspecciones: {},
      totalInspecciones: [],
      arrayFinal: [],
      viaje_id: null,
      viaje: null,
      accion: "",
      metodo: "",
      tipo: null,
      listaPeriocidad: [],
    };
  },
  methods: {
    puedeInspeccionarDesdeCargue(viaje) {
      // Obtener el tipo de sitio actual (1 = Sitio, 2 = PuntoGestion)
      const sitioType = this.$parent?.filtros?.sitio_type;
      const sitioActual = this.$parent?.filtros?.sitio_id;

      if (!viaje.det_solicitud_diaria) {
        // 1. Si está en punto de enturne (PuntoGestion), permitir siempre
        if (sitioType == 2 || sitioType == "App\\PuntoGestion") {
          return true;
        }

        // 2. Si está en sitio de cargue (Sitio), verificar si es el sitio de cargue del viaje
        if (sitioType == 1 || sitioType == "App\\Sitio") {
          const sitioCargueViaje =
            viaje?.sitio_cargue_id || viaje?.sitio_cargue?.id;

          // Si está en el sitio de cargue del viaje, permitir siempre
          if (
            sitioActual &&
            sitioCargueViaje &&
            sitioCargueViaje == sitioActual
          ) {
            return true;
          }
        }

        // 3. Si no está en punto de enturne ni en sitio de cargue,
        // aplicar validación de 2 horas después de salir del sitio de cargue
        const fechaSalidaCargue =
          viaje?.trazas_fechas_viaje?.fecha_salida_cargue ||
          viaje?.trazasFechasViaje?.fecha_salida_cargue;

        // Si no hay fecha de salida del sitio de cargue, no se puede inspeccionar
        if (!fechaSalidaCargue) {
          return false;
        }

        // Validar que esté dentro de las 4 horas después de salir del sitio de cargue
        const salida = this.parsearFechaHora(fechaSalidaCargue);
        if (!salida) {
          return false;
        }

        const ahora = new Date();
        const diffMs = ahora.getTime() - salida.getTime();
        const dosHorasMs = 4 * 60 * 60 * 1000;

        // Permitir inspección si han pasado entre 0 y 4 horas desde la salida del sitio de cargue
        return diffMs >= 0 && diffMs <= dosHorasMs;
      }
      return true;
    },

    parsearFechaHora(valor) {
      if (!valor) return null;
      if (valor instanceof Date) return valor;
      if (typeof valor !== "string") return null;

      const normalizado = valor.includes("T") ? valor : valor.replace(" ", "T");
      const fecha = new Date(normalizado);
      if (!Number.isNaN(fecha.getTime())) {
        return fecha;
      }

      const partes = valor.split(" ");
      if (partes.length !== 2) return null;
      const [fechaParte, horaParte] = partes;
      const [anio, mes, dia] = fechaParte.split("-").map(Number);
      const [hora, minuto, segundo] = horaParte.split(":").map(Number);
      if (!anio || !mes || !dia || hora === undefined || minuto === undefined) {
        return null;
      }
      return new Date(anio, mes - 1, dia, hora, minuto, segundo || 0);
    },

    async cargarInspecciones() {
      let me = this;
      await axios
        .get(
          "/api/hidrocarburos/ventanasEnturnamientoOperacion/cargarInspeccion?viaje_id=" +
            this.viaje_id +
            "&tipo=" +
            this.tipo,
        )
        .then(async (response) => {
          me.$parent.cargando = false;
          let res = response.data;

          if (res.Msg == "error") {
            //this.$refs.closeModal.click();
            if (res.errors.vehiculo.error !== undefined) {
              await this.$parent.msgDocumentacion(
                res.errors.vehiculo,
                "Vehiculo",
              );
            }
            if (res.errors.remolque.error !== undefined) {
              await this.$parent.msgDocumentacion(
                res.errors.remolque,
                "Remolque",
              );
            }
            if (res.errors.conductor.error !== undefined) {
              await this.$parent.msgDocumentacion(
                res.errors.conductor,
                "Conductor",
              );
            }
            // Aunque haya error de documentación, intentar cargar inspecciones si existen
            if (res.data && Array.isArray(res.data)) {
              me.totalInspecciones = res.data;
            } else {
              me.totalInspecciones = [];
            }
          } else if (res.Msg == "Ok") {
            // Asegurarse de que totalInspecciones sea un array
            me.totalInspecciones = Array.isArray(res.data) ? res.data : [];
            me.viajeInspecciones =
              res.data && res.data.length > 0 ? res.data[0] : null;
          } else {
            // Si no hay Msg, asumir que data contiene las inspecciones
            me.totalInspecciones = Array.isArray(res.data) ? res.data : [];
            me.viajeInspecciones =
              res.data && res.data.length > 0 ? res.data[0] : null;
          }

          me.arrayFinal = [];
          await this.cruceInspeccion();
        })
        .catch((error) => {
          me.$parent.cargando = false;
          me.totalInspecciones = [];
          me.arrayFinal = [];
        });
    },

    async cruceInspeccion() {
      this.arrayFinal = [];
      const formatosAsignados =
        this.inspecciones &&
        this.inspecciones[0] &&
        Array.isArray(this.inspecciones[0].inspecciones)
          ? this.inspecciones[0].inspecciones
          : [];

      const viaje = this.viaje || {};
      const postulacion = viaje.det_postulacion || {};
      const grupos = [
        this.totalInspecciones,
        viaje.inspecciones,
        viaje.todas_inspecciones,
        postulacion.inspecciones,
      ];

      formatosAsignados.forEach((element) => {
        const formatoId =
          (element.pivot && element.pivot.formato_inspeccion_id) || element.id;
        const cruce = {
          formato_inspeccion_id: formatoId,
          info_formato: element,
          info: null,
        };
        const filaEsPreoperacional = this.esFormatoPreoperacional(cruce);
        let preoperacional = null;

        grupos.forEach((grupo) => {
          if (!Array.isArray(grupo) || cruce.info) {
            return;
          }
          grupo.forEach((inspeccion) => {
            if (!inspeccion || cruce.info) {
              return;
            }
            const formato = inspeccion.formato_inspeccion || {};
            const esPreoperacional = this.esFormatoPreoperacional({
              info_formato: {
                nombre:
                  formato.nombre ||
                  inspeccion.nombre_formato ||
                  inspeccion.nombre,
                pre_operacional:
                  formato.pre_operacional || inspeccion.pre_operacional,
              },
            });
            const formatoIdInspeccion =
              inspeccion.formato_inspeccion_id != null
                ? inspeccion.formato_inspeccion_id
                : formato.id;

            if (esPreoperacional && !filaEsPreoperacional) {
              return;
            }
            if (
              formatoIdInspeccion != null &&
              String(formatoIdInspeccion) === String(formatoId)
            ) {
              cruce.info = inspeccion;
              return;
            }
            if (
              filaEsPreoperacional &&
              esPreoperacional &&
              (!preoperacional ||
                Number(inspeccion.id) > Number(preoperacional.id))
            ) {
              preoperacional = inspeccion;
            }
          });
        });

        if (!cruce.info && preoperacional) {
          cruce.info = preoperacional;
        }
        this.arrayFinal.push(cruce);
      });

      const tieneGuia = this.viaje && this.viaje.guia_id != null;
      const esGnv =
        this.viaje &&
        this.viaje.vehiculo &&
        this.viaje.vehiculo.tipo_combustible == 1;

      this.arrayFinal = this.arrayFinal.filter((item) => {
        if (item.info && item.info.id) {
          return true;
        }

        if (this.esFormatoPreoperacional(item)) {
          return true;
        }

        const formato = item.info_formato || {};
        const tipoOp = formato.tipo_operacion;

        if (this.esFormatoMarcadoGnv(formato)) {
          return !!esGnv;
        }

        if (this.tieneParGnvMismaPeriocidad(formato, formatosAsignados)) {
          return !esGnv;
        }

        if (tipoOp == 2 && !tieneGuia) {
          return false;
        }
        if (tipoOp == 1 && tieneGuia) {
          return false;
        }
        return true;
      });
    },

    esNombrePreoperacional(nombre) {
      const n = String(nombre || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
      return (
        n.indexOf("preoperacional") !== -1 || /pre[\s\-_.]*operacional/.test(n)
      );
    },

    esFormatoPreoperacional(item) {
      const formato =
        (item && (item.info_formato || item.formato_inspeccion)) || {};
      const flag = formato.pre_operacional;
      if (flag == 1 || flag === true || flag === "1" || flag === "true") {
        return true;
      }
      return this.esNombrePreoperacional(formato.nombre);
    },

    esFormatoMarcadoGnv(formato) {
      if (!formato) {
        return false;
      }
      if (formato.gnv == 1 || formato.gnv === true) {
        return true;
      }
      return /\bgnv\b/i.test(formato.nombre || "");
    },

    tieneParGnvMismaPeriocidad(formato, formatosAsignados) {
      if (!formato || !Array.isArray(formatosAsignados)) {
        return false;
      }
      return formatosAsignados.some((otro) => {
        if (!otro || otro.id == formato.id) {
          return false;
        }
        const otroItem = { info_formato: otro };
        if (this.esFormatoPreoperacional(otroItem)) {
          return false;
        }
        if (!this.esFormatoMarcadoGnv(otro)) {
          return false;
        }
        return (
          String(otro.periocidad ?? "") === String(formato.periocidad ?? "")
        );
      });
    },

    itemPeriocidad(formato) {
      const valor = formato && formato.periocidad;
      if (valor === null || valor === undefined || valor === "") {
        return null;
      }
      return (
        (this.listaPeriocidad || []).find(
          (item) =>
            String(item.numeracion) === String(valor) ||
            String(item.id) === String(valor),
        ) || null
      );
    },

    diasPeriocidad(formato) {
      const item = this.itemPeriocidad(formato);
      if (item && item.cod_alterno !== null && item.cod_alterno !== "") {
        const dias = Number(item.cod_alterno);
        if (!Number.isNaN(dias)) {
          return dias;
        }
      }
      const directo = Number(formato && formato.periocidad);
      return Number.isNaN(directo) ? null : directo;
    },

    normalizarTexto(valor) {
      return String(valor || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    },

    esCargueODescargue(formato) {
      const tipo = Number(formato && formato.tipo_operacion);
      return tipo === 1 || tipo === 2;
    },

    esFormatoMensual(item) {
      const formato = item && item.info_formato;
      if (!formato || this.esFormatoPreoperacional(item)) {
        return false;
      }
      if (this.diasPeriocidad(formato) === 30) {
        return true;
      }
      if (this.esFormatoMarcadoGnv(formato)) {
        return true;
      }
      const nombre = this.normalizarTexto(formato.nombre);
      if (
        nombre.indexOf("col-hs") !== -1 ||
        nombre.indexOf("mercancias peligrosas") !== -1
      ) {
        return true;
      }
      return !this.esCargueODescargue(formato);
    },

    mostrarBotonCrear(item) {
      if (!item || !this.viaje) {
        return false;
      }

      if (this.esFormatoPreoperacional(item)) {
        if (this.mensualEstaVencida(this.viaje, item)) {
          return false;
        }
        if (!item.info || !item.info.id) {
          return true;
        }
        const fecha = this.fechaSoloDia(
          item.info.fecha_inicio || item.info.created_at,
        );
        const hoy = this.fechaSoloDia(new Date());
        return !!(fecha && hoy && fecha.getTime() < hoy.getTime());
      }

      const mensualVencida = this.mensualEstaVencida(this.viaje, item);
      if (this.esFormatoMensual(item) || !this.esCargueODescargue(item.info_formato)) {
        return mensualVencida;
      }
      if (item.info && item.info.id || !mensualVencida) {
        return false;
      }
      return this.puedeCrearInspeccion(item);
    },

    fechaSoloDia(valor) {
      if (!valor) return null;
      if (valor instanceof Date) {
        if (Number.isNaN(valor.getTime())) return null;
        return new Date(valor.getFullYear(), valor.getMonth(), valor.getDate());
      }
      if (typeof valor !== "string") return null;

      const coincidencia = valor.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (coincidencia && !/[zZ]|[+-]\d{2}:?\d{2}$/.test(valor.trim())) {
        const anio = Number(coincidencia[1]);
        const mes = Number(coincidencia[2]);
        const dia = Number(coincidencia[3]);
        if (anio && mes && dia) {
          return new Date(anio, mes - 1, dia);
        }
      }

      const fecha = this.parsearFechaHora(valor);
      if (!fecha || Number.isNaN(fecha.getTime())) {
        return null;
      }
      return new Date(fecha.getFullYear(), fecha.getMonth(), fecha.getDate());
    },

    ultimaInspeccionMensual(viaje) {
      const vehiculo = viaje && viaje.vehiculo;
      if (!vehiculo) return null;
      return (
        vehiculo.ultima_inspeccion_vehiculo ||
        vehiculo.ultimaInspeccionVehiculo ||
        null
      );
    },

    fechaVencimientoDeMensual(ultima, formato) {
      if (ultima && ultima.fecha_vencimiento) {
        return this.fechaSoloDia(ultima.fecha_vencimiento);
      }
      if (!ultima) return null;
      const inicio = this.fechaSoloDia(
        ultima.fecha_inicio || ultima.created_at,
      );
      if (!inicio) return null;
      const dias = this.diasPeriocidad(
        formato || (ultima && ultima.formato_inspeccion) || {},
      );
      const diasVence = dias === 12 ? 365 : dias > 0 ? dias : 30;
      const vencimiento = new Date(inicio.getTime());
      vencimiento.setDate(vencimiento.getDate() + diasVence);
      return vencimiento;
    },

    mensualEstaVencida(viaje, item) {
      const ultima = this.ultimaInspeccionMensual(viaje);
      if (!ultima) {
        return true;
      }
      const formato = (item && item.info_formato) || null;
      const vencimiento = this.fechaVencimientoDeMensual(ultima, formato);
      const hoy = this.fechaSoloDia(new Date());
      if (!vencimiento || !hoy) {
        return true;
      }
      return hoy.getTime() > vencimiento.getTime();
    },

    mostrarNombreUltimaMensual(item) {
      if (!this.esFormatoMensual(item)) {
        return false;
      }
      const nombreUltima = this.nombreFormatoUltimaMensual(this.viaje);
      const nombreFila =
        item && item.info_formato && item.info_formato.nombre;
      return !!(nombreUltima && nombreUltima !== nombreFila);
    },

    formatearFechaCorta(valor) {
      if (!valor) {
        return "";
      }

      if (typeof valor === "string") {
        const coincidencia = valor.match(
          /^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?/,
        );
        if (coincidencia) {
          return (
            coincidencia[1] +
            "-" +
            coincidencia[2] +
            "-" +
            coincidencia[3] +
            " " +
            (coincidencia[4] || "00") +
            ":" +
            (coincidencia[5] || "00")
          );
        }
      }

      const fecha =
        valor instanceof Date ? valor : this.parsearFechaHora(valor);
      if (!fecha || Number.isNaN(fecha.getTime())) {
        return "";
      }
      const pad = (n) => String(n).padStart(2, "0");
      return (
        fecha.getFullYear() +
        "-" +
        pad(fecha.getMonth() + 1) +
        "-" +
        pad(fecha.getDate()) +
        " " +
        pad(fecha.getHours()) +
        ":" +
        pad(fecha.getMinutes())
      );
    },

    nombreFormatoUltimaMensual(viaje) {
      const ultima = this.ultimaInspeccionMensual(viaje);
      if (!ultima) return "";
      return (
        ultima.nombre_formato ||
        (ultima.formato_inspeccion && ultima.formato_inspeccion.nombre) ||
        ""
      );
    },

    mensualHechaEnDiaAnterior(viaje) {
      const ultima = this.ultimaInspeccionMensual(viaje);
      if (!ultima) return false;
      const fechaMensual = this.fechaSoloDia(
        ultima.fecha_inicio || ultima.created_at,
      );
      const hoy = this.fechaSoloDia(new Date());
      return !!(fechaMensual && hoy && hoy.getTime() > fechaMensual.getTime());
    },

    puedeCrearInspeccion(item) {
      if (!item || (item.info && item.info.id) || !this.viaje) {
        return false;
      }

      if (this.esFormatoPreoperacional(item) || this.esFormatoMensual(item)) {
        return false;
      }

      const formato = item.info_formato || {};
      const tieneGuia = this.viaje.guia_id != null;

      if (formato.tipo_operacion == 2 && !tieneGuia) {
        return false;
      }
      if (formato.tipo_operacion == 1 && tieneGuia) {
        return false;
      }

      if (!this.puedeInspeccionarDesdeCargue(this.viaje)) {
        return false;
      }

      return true;
    },

    async getInspecciones() {
      let me = this;
      me.$parent.cargando = true;
      await axios
        .get(
          "/api/hidrocarburos/ventanasEnturnamientoOperacion/inspeccionViaje?sitio_type=" +
            this.$parent.filtros.sitio_type +
            "&sitio_id=" +
            this.$parent.filtros.sitio_id +
            "&viaje_id=" +
            this.viaje_id +
            "&tipo=" +
            this.$parent.filtros.tipo_control,
        )
        .then((response) => {
          me.inspecciones = response.data;
        });
    },

    // edit() {
    //   var inspeccion = this.viajeInspecciones.id;
    //   alert(inspeccion);
    //   this.$refs.closeModal.click();
    //   return this.$router.push({
    //     name: "/Hidrocarburos/InspeccionForm",
    //     params: { inspeccion_id: inspeccion.id },
    //   });
    // },

    inspeccion(viaje, inspeccion) {
      this.$refs.closeModal.click();
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          viaje: viaje,
          inspeccion: inspeccion,
          sitio_type: this.$parent.filtros.sitio_type,
          sitio: this.$parent.slct_sitio,
          val: 0,
        },
      });
    },

    inspeccionPreoperacional(viaje) {
      this.$refs.closeModal.click();
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          viaje: viaje,
          sitio_type: this.$parent.filtros.sitio_type,
          sitio: this.$parent.slct_sitio,
          val: 0,
        },
      });
    },

    async getListaPeriocidad() {
      if (this.listaPeriocidad && this.listaPeriocidad.length > 0) {
        return;
      }
      const response = await axios.get("/api/lista/238");
      this.listaPeriocidad = Array.isArray(response.data) ? response.data : [];
    },

    async llenar_modal_inspeccion(viaje, tipo) {
      this.viaje_id = viaje.id;
      this.viaje = viaje;
      this.tipo = tipo;
      await this.getListaPeriocidad();
      await this.getInspecciones();
      await this.cargarInspecciones();

      // Si el viaje ya tiene inspecciones cargadas y totalInspecciones está vacío, usarlas
      if (
        viaje.inspecciones &&
        Array.isArray(viaje.inspecciones) &&
        viaje.inspecciones.length > 0
      ) {
        if (this.totalInspecciones.length === 0) {
          this.totalInspecciones = viaje.inspecciones;
          await this.cruceInspeccion();
        }
      }
    },

    edit(inspeccion_id) {
      this.$refs.closeModal.click();
      return this.$router.push({
        name: "/Hidrocarburos/InspeccionForm",
        params: {
          inspeccion_id: inspeccion_id,
        },
      });
    },

    valInspeccionFechas(viaje, item) {
      const vehiculo = viaje?.vehiculo;
      if (!vehiculo) return false;
      return this.mensualEstaVencida(viaje, item);
    },

    permiteInspeccionMensual(viaje, item) {
      if (!viaje || !viaje.vehiculo) {
        return false;
      }
      return this.mensualEstaVencida(viaje, item);
    },

    valInspeccionFechasMsg(viaje, item) {
      const vehiculo = viaje?.vehiculo;
      const ultima = this.ultimaInspeccionMensual(viaje);
      if (!vehiculo) return "";
      if (!ultima) return "Sin inspección";

      const vencimiento = this.fechaVencimientoDeMensual(ultima);
      const hoy = this.fechaSoloDia(new Date());
      const textoVencimiento = this.formatearFechaCorta(
        ultima.fecha_vencimiento || vencimiento,
      );

      if (!textoVencimiento) {
        return "Sin fecha de vencimiento";
      }

      const vencida =
        hoy && vencimiento && hoy.getTime() > vencimiento.getTime();
      return vencida
        ? "Vencida: " + textoVencimiento
        : "Vence: " + textoVencimiento;
    },

    /**
     * Lógica pura (sin mutar estado del componente). Mutar `data` desde métodos
     * llamados en plantilla (:class, {{ }}) provoca re-renders en cadena y puede
     * disparar bucles o "Maximum update depth exceeded".
     */
    estadoInspeccionVehiculoBadge(viaje) {
      const vehiculo = viaje?.vehiculo;
      const ultima = this.ultimaInspeccionMensual(viaje);
      let bg = "";
      let puedePreoperacional = false;

      if (!vehiculo) {
        return { bg: "bg-danger", puedePreoperacional: false };
      }
      if (ultima) {
        const vencida = this.mensualEstaVencida(viaje);
        bg = vencida ? "bg-danger" : "bg-success";
        puedePreoperacional = !vencida;
      } else {
        bg = "bg-danger";
        puedePreoperacional = false;
      }

      return { bg, puedePreoperacional };
    },

    valInspeccionFechasMsgBadge(viaje) {
      return this.estadoInspeccionVehiculoBadge(viaje).bg;
    },

    permiteInspeccionPreoperacional(viaje) {
      if (!viaje) {
        return false;
      }
      if (this.mensualEstaVencida(viaje)) {
        return false;
      }
      return true;
    },
  },
  mounted() {},
};
</script>
